module.exports = __webpack_public_path__ + "static/media/zanfini.4d1fa1b8.PNG";